import CircularProgress from '@/elements/circular-progress';

function LoadingState() {
  return (
    <div className='flex items-center justify-center w-10 h-10'>
      <CircularProgress className='w-7 h-7' />
    </div>
  );
}

export default LoadingState;
